import { render } from "./TextPair.vue?vue&type=template&id=449e4654"
import script from "./TextPair.vue?vue&type=script&lang=js"
export * from "./TextPair.vue?vue&type=script&lang=js"

import "./TextPair.vue?vue&type=style&index=0&id=449e4654&lang=scss&scope=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__